import { render } from "./FundHistoryRebate.vue?vue&type=template&id=0db6d2de&scoped=true"
import script from "./FundHistoryRebate.vue?vue&type=script&lang=js"
export * from "./FundHistoryRebate.vue?vue&type=script&lang=js"

import "./FundHistoryRebate.vue?vue&type=style&index=0&id=0db6d2de&lang=less&scoped=true"
import "./FundHistoryRebate.vue?vue&type=style&index=1&id=0db6d2de&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db6d2de"]])

export default __exports__